module.exports = __webpack_public_path__ + "c5957a91308afa39661dce47d6f68309.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/category_icons/ic_pinproducts.png
// module id = 952
// module chunks = 0